<template>
  <div class="d-flex align-items-center p-1 rounded border h-100">
    <div class="p-2" :style="{ color: accentColor }">
      <div
        v-if="section.icon || editable"
        :class="{
          'border rounded': iconFocused && editable,
          'cursor-pointer': editable,
        }"
        :style="iconFocused && editable ? { borderColor: accentColor + ' !important' } : {}"
        class="d-flex align-items-center border border-0"
        style="font-size: 42px"
        tabindex="0"
        @focusout="iconFocused = false"
        @click="iconFocused = !iconFocused"
      >
        <div
          v-if="iconFocused && editable"
          class="position-absolute bg-white rounded p-1 shadow-sm border z-index-10"
          style="margin-left: -55px"
        >
          <div class="d-flex flex-column p-1" style="gap: 14px">
            <b-icon icon="trash" class="font-size-sm" @click="selectIcon(null)" />
            <div class="d-flex border" />
            <div
              @click.stop="selectIcon(icon)"
              :key="icon"
              v-for="icon in iconOptions"
              class="d-flex flex-column"
              style="gap: 14px"
            >
              <b-icon :icon="icon" class="font-size-sm" />
            </div>
          </div>
        </div>
        <b-icon :icon="localSection.icon || 'question'" />
      </div>
    </div>
    <div class="p-2 d-flex flex-column justify-content-center flex-grow-1 overflow-hidden">
      <div class="font-weight-bold" style="font-size: 16px">
        <div class="font-weight-bold" :style="{ color: accentColor, fontSize: '45px' }">
          <EditableField
            truncate
            :editable="editable"
            v-model="localSection.value"
            name="value"
            placeholder="Number"
            @editable_field:save="updateValue"
          />
        </div>
        <EditableField
          truncate
          :editable="editable"
          v-model="localSection.title"
          name="title"
          placeholder="Qualifier"
          @editable_field:save="updateTitle"
        />
      </div>
      <div style="font-size: 16px">
        <EditableField
          :editable="editable"
          v-model="localSection.caption"
          name="caption"
          placeholder="Tagline"
          @editable_field:save="updateCaption"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import SectionMixin from '@app/mixins/case_study_section'
import EditableField from '@app/components/EditableField.vue'

const ICONS = [
  'arrow-up',
  'arrow-down-left',
  'arrow-up-right',
  'gem',
  'heart',
  'stopwatch',
  'lightbulb',
  'star',
]

export default {
  name: 'StatSection',
  components: { EditableField },
  mixins: [SectionMixin],
  data() {
    return {
      iconFocused: false,
      localSection: { ...this.section },
    }
  },
  props: {
    caseStudyId: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
    section: { type: Object, required: true },
    accentColor: { type: String, required: true },
    position: { type: String, required: true },
  },
  watch: {
    section: {
      handler(newSection) {
        this.localSection = { ...newSection }
      },
      deep: true,
    },
  },
  computed: {
    editableText() {
      return this.editable ? true : null
    },
    displayValue() {
      return this.localSection.value
    },
    iconName() {
      return this.localSection.icon
    },
    iconOptions() {
      return ICONS
    },
  },
  methods: {
    selectIcon(icon) {
      this.localSection.icon = icon
      this.$emit('icon-selected', icon, this.position)
      this.iconFocused = false
    },
    updateTitle(newContent) {
      this.$emit('stat-updated', this.localSection, 'title', newContent, this.position)
    },
    updateValue(newContent) {
      this.$emit('stat-updated', this.localSection, 'value', newContent, this.position)
    },
    updateCaption(newContent) {
      this.$emit('stat-updated', this.localSection, 'caption', newContent, this.position)
    },
  },
}
</script>
<style lang="sass" scoped>
.cursor-pointer
  cursor: pointer

.font-size-sm
  font-size: 18px

.font-size-sm:hover
  color: v-bind(accentColor)

.z-index-10
  z-index: 10
</style>
